import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const referencePeriodSchema = z.object({
  id: z.string(),
  code: z.string(),
  Start_Date: z.coerce.date(),
  End_Date: z.coerce.date(),
  is_active: z.boolean(),
});

export class ReferencePeriodDto extends createZodDto(referencePeriodSchema) {}
